export const getInitials = (name) => {
    return name.split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };
  
  export const getSpaceColor = (space) => {
    const colors = ['#FF9E5E', '#FF6B8B', '#7FD8BE', '#94AEFF', '#C792EA', '#80CBC4'];
    let hash = 0;
    if (space.id) {
      for (let i = 0; i < space.id.length; i++) {
        hash = space.id.charCodeAt(i) + ((hash << 5) - hash);
      }
    }
    return colors[Math.abs(hash) % colors.length];
  };
  
  export const getMemberStatus = (status) => {
    switch(status) {
      case 'pending': return 'Pending';
      case 'accepted': return 'Member';
      case 'rejected': return 'Rejected';
      case 'left': return 'Left';
      default: return status;
    }
  };